import { useEffect } from "react";

const useOnLoadListener = (handlerFunction: () => void) => {
  useEffect(() => {
    function onLoad() {
      handlerFunction();
    }
    if (document.readyState === "complete") {
      handlerFunction();
    } else {
      window.addEventListener("load", onLoad);
      return () => {
        window.removeEventListener("load", onLoad);
      };
    }
  }, [handlerFunction]);
};

export default useOnLoadListener;